const AdminHomeTableRowSubscribe = ({ userPhoneNo,userMail }) =>{

    return(
         
             
        <tr>
            <td>{userPhoneNo}</td>
            <td>{userMail}</td>
         </tr>
         
  
    );
   
}
export default AdminHomeTableRowSubscribe;


